const Layout = () => import('@/components/layout/index.vue')

/**
 * 说明：
  router meta 结合Layout组件有5个可配置选项：
  1.title，会显示在layout的头部header的文字
  2.icon，控制layout底部菜单区按钮的图标, 图标来源vant官网
  3.bottomMenu，是否显示底部菜单，设置它为false就不用设置icon了，下面只是示例。
  4.showHeader，是否显示头部header条，设置它为false就不用设置title了，下面只是示例。
  5.keepAlive，是否应用缓存，会存储到store里。
 */

const routeModuleList = [
  // {
  //   path: '/index',
  //   name: 'Index',
  //   meta: {
  //     title: '首页',
  //     icon: 'wap-home',
  //     bottomMenu: true,
  //     hiddenHeader: false // 此属性会隐藏头部Bar title
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'WelcomePage',
  //       meta: {
  //         keepAlive: false,
  //         title: '欢迎' // 此处定义的title会覆盖父级定义的title
  //       },
  //       component: () => import('@/views/welcome/index.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/about',
  //   name: 'AboutView',
  //   redirect: '/about/index',
  //   meta: {
  //     title: '关于我们',
  //     bottomMenu: true,
  //     icon: 'manager'
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'AboutView',
  //       meta: {
  //         keepAlive: true,
  //         title: '我们',
  //         hiddenHeader: true // 此属性会隐藏头部Bar title
  //       },
  //       component: () => import('@/views/AboutView.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/themeSetting',
  //   name: 'ThemeSetting',
  //   meta: {
  //     title: '主题设置',
  //     bottomMenu: true,
  //     icon: 'CashOutline',
  //   },
  //   component: () => import('@/views/my/ThemeSetting.vue')
  // }
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页',
      bottomMenu: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/index.vue'),
    children: [
      {
        path: '/home/productDetails',
        name: 'Home-productDetails',
        meta: {
          keepAlive: false,
          showHeaderNavBar: true,
          title: '商品详情'
        },
        component: () => import('@/views/home/productDetails.vue')
      }
    ]
  },
  {
    path: '/index',
    name: 'Index',
    meta: {
      title: '首页',
      bottomMenu: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/index.vue'),
    children: [
      {
        path: '/index/productDetails',
        name: 'Index-productDetails',
        meta: {
          keepAlive: false,
          showHeaderNavBar: true,
          title: '商品详情'
        },
        component: () => import('@/views/home/productDetails.vue')
      }
    ]
  },
  {
    path: '/productList',
    name: 'ProductList',
    meta: {
      title: '商品列表',
      bottomMenu: true,
      // showHeaderNavBar: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/productList.vue'),
    children: [
      {
        path: '/productList/productDetails',
        name: 'ProductList-productDetails',
        meta: {
          keepAlive: false,
          showHeaderNavBar: true,
          title: '商品详情'
        },
        component: () => import('@/views/home/productDetails.vue')
      }
    ]
  },
  // {
  //   path: '/productDetails',
  //   name: 'ProductDetails',
  //   meta: {
  //     title: '商品详情',
  //     bottomMenu: true,
  //     icon: 'wap-home',
  //   },
  //   component: () => import('@/views/home/productDetails.vue')
  // },
  {
    path: '/confirmOrder',
    name: 'ConfirmOrder',
    meta: {
      title: '确认订单',
      bottomMenu: true,
      showHeaderNavBar: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/confirmOrder.vue')
  },
  {
    path: '/orderList',
    name: 'OrderList',
    meta: {
      title: '订单列表',
      bottomMenu: true,
      showHeaderNavBar: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/orderList.vue')
  },
  {
    path: '/orderDetails',
    name: 'OrderDetails',
    meta: {
      title: '订单详情',
      bottomMenu: true,
      showHeaderNavBar: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/orderDetails.vue')
  },
  {
    path: '/search',
    name: 'Search',
    meta: {
      title: '搜索页',
      bottomMenu: true,
      showHeaderNavBar: true,
      icon: 'wap-home',
    },
    component: () => import('@/views/home/search.vue')
  }
]

export default routeModuleList
